import React from 'react';

function About() {
  const images = [
    { src: '/s2.jpg', alt: 'Site Safety 2' },
    { src: '/s3.jpg', alt: 'Site Safety 3' },
    { src: '/s4.jpg', alt: 'Site Safety 4' },
    { src: '/s5.jpg', alt: 'Site Safety 5' },
  ];

  return (
    <div className="min-h-screen bg-black">
      <section className="relative flex min-h-[22rem] items-center overflow-hidden bg-black py-16 text-white md:min-h-[28rem] md:py-20">
        <div className="absolute inset-0">
          <img
            src="/about-hero.jpg"
            alt=""
            className="h-full w-full object-cover"
            fetchPriority="high"
            decoding="async"
          />
        </div>
        <div className="absolute inset-0 bg-black/45" aria-hidden="true" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-white md:text-5xl lg:text-6xl">
            About CSO Site Safety
          </h1>
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-900 rounded-lg shadow-lg p-8 md:p-12 mb-8 border border-gray-800">
              <div className="mb-6 rounded-lg overflow-hidden">
                <img 
                  src="/IMG_20261004_095434862.jpg" 
                  alt="Our Mission" 
                  loading="lazy"
                  decoding="async"
                  className="w-full h-80 object-cover"
                />
              </div>
              <h2 className="text-3xl font-semibold text-white mb-6">Our Mission</h2>
              <p className="text-gray-300 leading-relaxed mb-4 text-lg">
                At CSO Site Safety Services Inc, we are dedicated to providing top-notch construction safety solutions. 
                Our mission is to ensure a safe working environment for all personnel on site, prioritizing safety 
                without compromising efficiency.
              </p>
              <p className="text-gray-300 leading-relaxed text-lg">
                We understand that construction sites can be hazardous environments, and our goal is to minimize risks 
                while maintaining productivity. Through comprehensive safety planning, regular audits, continuous monitoring, 
                and professional training, we help construction companies create safer workplaces.
              </p>
            </div>

            <div className="bg-gray-900 rounded-lg shadow-lg p-8 md:p-12 border border-gray-800">
              <div className="mb-6 rounded-lg overflow-hidden">
                <img 
                  src="/IMG_0827.jpg" 
                  alt="Our Services" 
                  loading="lazy"
                  decoding="async"
                  className="w-full h-80 object-cover"
                />
              </div>
              <h2 className="text-3xl font-semibold text-white mb-6">Services</h2>
              <p className="text-gray-300 leading-relaxed mb-6 text-lg">
                We offer comprehensive construction site safety services designed to protect your workforce and ensure 
                regulatory compliance:
              </p>
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-start">
                  <span className="text-white mr-3 text-xl">✓</span>
                  <div>
                    <strong className="text-white">Safety Plans</strong>
                    <p className="text-gray-400">Customized safety plans tailored to your specific project requirements</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-white mr-3 text-xl">✓</span>
                  <div>
                    <strong className="text-white">Auditing</strong>
                    <p className="text-gray-400">Regular safety audits to identify potential hazards and ensure compliance</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-white mr-3 text-xl">✓</span>
                  <div>
                    <strong className="text-white">Monitoring</strong>
                    <p className="text-gray-400">Continuous on-site monitoring to maintain safety standards</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="text-white mr-3 text-xl">✓</span>
                  <div>
                    <strong className="text-white">Training</strong>
                    <p className="text-gray-400">Professional safety training programs, including in-class fall protection training</p>
                  </div>
                </li>
              </ul>
              <div className="mt-8 p-4 bg-gray-800 rounded-lg border-l-4 border-gray-600">
                <p className="text-gray-200 font-medium">
                  <strong className="text-white">NEW:</strong> Discover Our Latest Course Offerings — Designed to Support Your Workers’ Training and Education Needs
                </p>
              </div>
            </div>

            {/* Image Gallery */}
            <div className="mt-12">
              <h2 className="text-3xl font-semibold text-white mb-8 text-center">Our Safety Solutions</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {images.map((image, index) => (
                  <div 
                    key={index} 
                    className="relative group overflow-hidden rounded-lg border border-gray-800 hover:border-gray-600 transition-all"
                  >
                    <img 
                      src={image.src} 
                      alt={image.alt}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8 rounded-lg overflow-hidden max-w-4xl mx-auto border border-gray-800">
            <img 
              src="/IMG_0414.jpg" 
              alt="Construction Safety" 
              loading="lazy"
              decoding="async"
              className="w-full h-96 object-cover"
            />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Construction Safety, one project at a time
          </h2>
          <div className="w-24 h-1 bg-gray-600 mx-auto"></div>
          <p className="text-gray-300 mt-6 max-w-2xl mx-auto text-lg">
            At CSO Site Safety Services Inc, we believe that every construction project deserves the highest level 
            of safety attention. We work closely with our clients to ensure that safety is integrated into every 
            aspect of the project, from planning to completion.
          </p>
        </div>
      </section>
    </div>
  );
}

export default About;
